"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenExplorerPage = void 0;
const react_1 = __importStar(require("react"));
const button_1 = require("@shared-modules/components/button");
const nft_token_card_list_1 = require("@components/nft-token-card-list");
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const token_hooks_1 = require("@hooks/token.hooks");
const loader_1 = require("@shared-modules/components/loader");
const stub_cards_1 = require("@components/stub-cards");
const nft_filters_1 = require("@components/nft-filters");
const react_router_dom_1 = require("react-router-dom");
const http_1 = require("@utils/http");
const TokenExplorerPage = () => {
    const { search } = (0, react_router_dom_1.useLocation)();
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const { type, sorting, sortingProperty } = (0, http_1.parseQuery)(search);
    const [filters, setFilters] = (0, react_1.useState)({ types: type ? [type] : [], sorting, sortingProperty });
    const { list: tokenList, nextPage, isLastPage, isFirstLoadCompleted } = (0, token_hooks_1.useTokenListByFilter)(Object.assign({}, filters));
    return (react_1.default.createElement("div", { className: "p-token-explorer-page" },
        react_1.default.createElement("div", { className: "p-token-explorer-page__filters" },
            react_1.default.createElement(nft_filters_1.NftFilters, { initial: filters, updateFilters: setFilters })),
        react_1.default.createElement("div", { className: "p-token-explorer-page__section-container" },
            isFirstLoadCompleted && (react_1.default.createElement("div", { className: "p-token-explorer-page__container" },
                react_1.default.createElement(nft_token_card_list_1.NFTTokenCardList, { list: tokenList }),
                react_1.default.createElement(stub_cards_1.StubCards, null))),
            !isFirstLoadCompleted && (react_1.default.createElement("div", { className: "p-token-explorer-page__loader" },
                react_1.default.createElement(loader_1.Loader, { scale: 1 }))),
            !isLastPage && (react_1.default.createElement("div", { className: "p-token-explorer-page__button" },
                react_1.default.createElement(button_1.Button, { type: "thirtery", onClick: nextPage }, commonTranslator("loadMoreButton")))))));
};
exports.TokenExplorerPage = TokenExplorerPage;
exports.default = exports.TokenExplorerPage;
